import { getFormattedName } from "../screens/utils/vehicleName.js";

const SEGMENT_LABELS = {
  articles: "Article",
  audioMultimedia: "Audio & Multimedia",
  browse: "Browse",
  certification: "Certification",
  contact: "Contact",
  details: "Details",
  eBrochures: "eBrochures",
  "engage-xp": "Engage XP",
  engageResources: "Engage Resources",
  ev: "EV",
  glossary: "Glossary",
  home: "Home",
  hybrid: "Hybrid",
  myaccount: "My Account",
  news: "News",
  product: "Product",
  resources: "Resources",
  safety: "Safety",
  search: "Search",
  smartPath: "SmartPath",
  sourcebooks: "Vehicle Sourcebooks",
  termsConditions: "Terms & Conditions",
  towingPayload: "Towing & Payload",
  toyotaSafetySense: "Toyota Safety Sense",
  vinLookup: "VIN Lookup",
};

function humanizeSegment(segment = "") {
  const decodedSegment = decodeURIComponent(segment);
  const mappedLabel = SEGMENT_LABELS[decodedSegment];

  if (mappedLabel) {
    return mappedLabel;
  }

  return decodedSegment
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function resolveTrackedPageTitle(pathname = "") {
  const segments = pathname.split("/").filter(Boolean);

  if (segments.length === 0) {
    return "Home";
  }

  const [root, first, second, third, fourth] = segments;

  // Article pages are /articles/<article_id>/<slug>: label them by the slug,
  // never the ID. The title itself loads async, so it usually isn't set yet.
  if (root === "articles" && first) {
    if (/^\d+$/.test(first)) {
      return second
        ? `Article - ${humanizeSegment(second)}`
        : SEGMENT_LABELS.articles;
    }
    return `Article - ${humanizeSegment(first)}`;
  }

  if (root === "product" && first) {
    const modelYear = second && /^\d{4}$/.test(second) ? second : "";
    const modelName = getFormattedName(
      first,
      false,
      modelYear ? Number(modelYear) : -1,
    );
    const pageSegment = fourth || third || "overview";
    const pageLabel = humanizeSegment(pageSegment);
    const vehicleLabel = [modelYear, modelName].filter(Boolean).join(" ");

    return vehicleLabel ? `${vehicleLabel} - ${pageLabel}` : pageLabel;
  }

  if (root === "towingPayload") {
    const modelYear = second && /^\d{4}$/.test(second) ? second : "";
    const modelName = getFormattedName(
      first || "",
      false,
      modelYear ? Number(modelYear) : -1,
    );
    const vehicleLabel = [modelYear, modelName].filter(Boolean).join(" ");

    return vehicleLabel
      ? `${SEGMENT_LABELS.towingPayload} - ${vehicleLabel}`
      : SEGMENT_LABELS.towingPayload;
  }

  if (root === "myaccount") {
    return first
      ? `${SEGMENT_LABELS.myaccount} - ${humanizeSegment(first)}`
      : SEGMENT_LABELS.myaccount;
  }

  if (root === "pages") {
    if (second) {
      return `${humanizeSegment(first)} - ${humanizeSegment(second)}`;
    }

    return humanizeSegment(first || "pages");
  }

  if (first) {
    return `${humanizeSegment(root)} - ${humanizeSegment(first)}`;
  }

  return humanizeSegment(root);
}
